import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { FDImage } from '@facet-wealth/design';

const TaxDiagnosticMessageFacetIconPicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.facetIcon.name,
    (rel) => (
      <FDImage src={rel.link('related').url()} alt={rel.meta('altText') ?? 'Facet Icon'} maxHeight={'50px'} />
    ),
    () => null,
  );
};

TaxDiagnosticMessageFacetIconPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TaxDiagnosticMessageFacetIconPicker.defaultProps = {
};

export default TaxDiagnosticMessageFacetIconPicker;
